import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Flex,
  Link as StyledLink,
  Text,
} from "rebass";

import { Divider } from "../styled/Divider";
import { SignInWith } from "../SignInWith";


interface IProps {
  type: "in" | "up";
  children?: React.ReactNode;
}

const contentList = {
  in: {
    link: {
      title: "Sign Up",
      to: "sign-up",
      label: "Do not have an account?",
    },
    title: "Sign In",
  },
  up: {
    link: {
      title: "Sign In",
      to: "sign-in",
      label: "Already have an account?",
    },
    title: "Sign Up",
  },
};

export function SignLayout({ type, children }: IProps) {
  const {
    link,
    title,
  } = contentList[type];

  return (
    <Flex
      height="100%"
      flexDirection="column"
      p="65px 100px 35px"
    >
      <Text
        as="h3"
        fontSize="30px"
        fontWeight="bold"
        lineHeight={1.07}
        color="#2b3160"
      >
        {title}
      </Text>

      <Box mt="40px">
        {children}
      </Box>

      <Divider my="20px">
        <Text
          mx="15px"
          fontSize="14px"
          fontWeight="bold"
          color="wild-blue"
        >
          or
        </Text>
      </Divider>

      <SignInWith type={type} />

      <Box mt="40px">
        <Text
          as="p"
          fontSize="14px"
          lineHeight={1.57}
          color="wild-blue"
        >
          <span>{link.label}</span>

          &nbsp;

          <Link to={`/settings/${link.to}`}>{link.title}</Link>
        </Text>

        <Text
          as="p"
          fontSize="14px"
          lineHeight={1.57}
          color="wild-blue"
        >
          <Link to="/settings/send-reset-link">Forgot password?</Link>
        </Text>
      </Box>

      <Text
        as="p"
        mt="auto"
        fontSize="14px"
        lineHeight={1.57}
        color="wild-blue"
      >
        <span>By continuing you accept the</span>

        &nbsp;

        <StyledLink
          color="inherit"
          href={process.env.REACT_APP_TERMS_OF_SERVICE_URL}
        >
          Terms of Use
        </StyledLink>

        &nbsp;

        <span>and</span>

        &nbsp;

        <StyledLink
          color="inherit"
          href={process.env.REACT_APP_PRIVACY_POLICY_URL}
        >
          Privacy Policy
        </StyledLink>
      </Text>
    </Flex>
  );
}
